import { Bell } from 'lucide-react'
import { useMemo } from 'react'

import SetupMenu from '@/components/global/setup-menu'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card'
import { useBrandingSelector } from '@/store'

const NotifsHover = () => {
  const { logo, color, domain, domainIsVerified } = useBrandingSelector()

  const { brandingComplete, domainComplete, allComplete } = useMemo(() => {
    const brandingComplete = !!logo && !!color
    const domainComplete = !!domain && !!domainIsVerified
    const allComplete = brandingComplete && domainComplete
    return { brandingComplete, domainComplete, allComplete }
  }, [logo, color, domain, domainIsVerified])

  return (
    <HoverCard openDelay={0} closeDelay={0}>
      <HoverCardTrigger asChild>
        <Button
          size="icon"
          variant="outline"
          className="group text-muted-foreground hover:text-foreground data-[state=open]:text-foreground !cursor-pointer relative"
          data-testid="notifications-button"
        >
          <Bell size={18} className="transition-transform" />
          {!allComplete && (
            <Badge
              variant="destructive"
              className="absolute flex items-center justify-center p-0 text-[8px] -top-2 -right-2 h-4 w-4 rounded-sm"
            >
              {Number(!brandingComplete) + Number(!domainComplete)}
            </Badge>
          )}
        </Button>
      </HoverCardTrigger>
      <HoverCardContent className="w-56 p-1 -mt-1" align="end">
        {!allComplete ? (
          <SetupMenu brandingComplete={brandingComplete} domainComplete={domainComplete} />
        ) : (
          <div className="flex flex-col items-center justify-center py-6 text-center">
            <div className="relative flex items-center justify-center p-6 mb-3 bg-gray-100 rounded-2xl">
              <Bell className="w-6 h-6 text-gray-700" />
            </div>
            <p className="text-sm text-muted-foreground">No notifications</p>
            <p className="mt-1 text-xs text-muted-foreground/70">You&apos;re all caught up!</p>
          </div>
        )}
      </HoverCardContent>
    </HoverCard>
  )
}

export default NotifsHover
